import { useEffect, useState } from "react";
import { Header } from "../../elements/header/Header";
import VideoPreviewPlaceholder from "../../elements/video-preview/placeholder";
import Video from "../../elements/video-preview/video";
import { requestJSONBy } from "../../functions/api/fetcher";

export default function App() {
  const [videosList, setVideosList] = useState(null);
  useEffect(() => {
    requestJSONBy('/api/v1/get_recomendations.php', (data) => {
      setVideosList(data.videos);
      // setVideosList([]);
    }, () => {
        setVideosList([]);
    })
  }, [])
  return (
    <>
      <Header />
      <div className="gallery">
        {videosList === null? [...Array(30)].map((e, i) => <VideoPreviewPlaceholder  key={i} />):""  /* Placeholder */}
        {videosList?.length > 0 && <VideosList videos={videosList} />}
      </div>
      {videosList?.length === 0 && <NoVideos />}
    </>
  );
}

function NoVideos() {
  return <p style={{textAlign: "center"}}>Нету видосов. Ужас, да?</p>
}

function VideosList({videos}) {
  return <>
    {
      videos.map(element => {
        return <Video video={element} />
      })
    }
  </>
}
